import { ConfigProvider } from 'antd';
import { useEffect } from 'react';
import { IntlProvider } from "react-intl";
import themeConfig from './configs/themeConfig';
import AppLocale from './languages';
import Router from "./router/Router";

export default function App() {
  // Lang
  const currentAppLocale = AppLocale[themeConfig.language];

  useEffect(() => {
    document.querySelector("html").setAttribute("lang", themeConfig.language);
  }, [themeConfig]);

  return (
    <ConfigProvider locale={currentAppLocale.antd} direction={themeConfig.direction}>
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <Router />
      </IntlProvider>
    </ConfigProvider>
  );
}